import { useRecoilState, useRecoilValue } from 'recoil'
import faqAtom from '../faq.atom'
import { useEffect } from 'react'
import faqApi from '../faq.api'
import useHttpLoader from '../../../../shared/hooks/useHttpLoader'
import faqSelectors from '../faq.selectors'

const useFaqState = () => {
  const { wait, loading } = useHttpLoader()
  const [faqState, setFaqState] = useRecoilState(faqAtom)



  const categoriesMap = useRecoilValue(faqSelectors.faqCategoriesMap)

  useEffect(() => {
    if (faqState.loaded) return
    const job = async () => {
      const categories = await faqApi.categoriesList()
      const articles = await faqApi.articlesList()

      if (categories.status === 'success' && articles.status === 'success') {
        return {
          categories: categories.body,
          articles: articles.body,
        }
      }

      return {
        categories: [],
        articles: [],
      }
    }

    wait(job(), (resp) => {
      setFaqState((prev) => ({ ...prev, loaded: true, articles: resp.articles, categories: resp.categories }))
    })
  }, [])

  return {
    loaded: faqState.loaded,
    loading,
    categories: faqState.categories,
    categoriesMap,
    articles: faqState.articles,
  }
}

export default useFaqState
